<template>
  <div>
    <common-expansion-panel :currentPanel="currentPanel" :readonly="readonly">
      <template v-slot:title-panel>
        <span class="titulo-header">Datos del vehículo</span>
      </template>
      <v-expansion-panel-content>
        <span class="text-body-1 px-1"
          >¿Nos ayudas con los datos de tu vehículo?</span
        >
        <v-form ref="form" v-model="isFormValid" lazy-validation class="mt-5">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="marca" outlined disabled>
                <template #label>
                  <span>Marca <span class="red--text">*</span></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="model" outlined disabled>
                <template #label>
                  <span>Año <span class="red--text">*</span></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="description" outlined disabled>
                <template #label>
                  <span>Descripción <span class="red--text">*</span></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="vehicle_vin"
                outlined
                :rules="[
                  $rules.required,
                  localRules.alphanumeric,
                  $rules.min(15),
                  $rules.max(17),
                ]"
                :maxLength="17"
                :error-messages="errors.vin"
              >
                <template #label>
                  <span>No. de Serie <span class="red--text">*</span></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="vehicle_plate"
                    outlined
                    :maxlength="7"
                    :rules="[
                      $rules.required,
                      localRules.alphanumeric,
                      localRules.sixDigits,
                    ]"
                    v-on="on"
                  >
                    <template #label>
                      <span>Placas <span class="red--text">*</span></span>
                    </template>
                  </v-text-field>
                </template>
                <span>Si no conoces el numero de placa coloca '0000000'.</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12">
              <div class="d-flex justify-center">
                <span class="text-body-1"
                  ><span class="red--text">*</span> Campos obligatorios</span
                >
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-checkbox
                color="#00a7e4"
                v-model="requiredChecks['1']"
                label="El vehículo que quiero asegurar nunca ha sido declarado pérdida total."
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                color="#00a7e4"
                v-model="requiredChecks['2']"
                label="El vehículo que quiero asegurar no es un auto fronterizo o legalizado."
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                color="#00a7e4"
                v-model="requiredChecks['3']"
                label="El vehículo que quiero asegurar no se usa para prestar servicios en apps de transporte privado."
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                color="#00a7e4"
                v-model="requiredChecks['4']"
                label="El vehículo que quiero asegurar no se usa para nada comercial."
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                block
                rounded
                dark
                outlined
                color="#00a7e4"
                @click="$router.go(-1)"
              >
                <span style="padding-right: 11%;">
                  Regresar
                </span>
              </v-btn>
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                block
                rounded
                dark
                class="common-botton"
                :disabled="!isFormValid || !allChecksActive || loading"
                :loading="loading"
                @click="nextStep()"
              >
                <span style="padding-right: 11%;">
                  Siguiente
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-expansion-panel-content>
    </common-expansion-panel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import validateVin from "@/services/vinValidator.service";

export default {
  components: {
    CommonExpansionPanel,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    useSameVinAndSameQuotation: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentPanel: 0,
      isFormValid: false,
      loading: false,
      requiredChecks: {
        1: false,
        2: false,
        3: false,
        4: false,
      },

      localRules: {
        alphanumeric: (v) =>
          !v ||
          !!v.match(/^[0-9a-zA-Z]+$/) ||
          "Este campo solo acepta letras y números",
      },

      errors: {
        vin: [],
      },

      cotizacionSelected: JSON.parse(
        sessionStorage.getItem("cotizacionSelected")
      ),
    };
  },

  computed: {
    marca: {
      get() {
        return this.$store.state.emission.carData.brand;
      },
      set(value) {
        this.$store.dispatch("updateCarDataProperty", { key: "brand", value });
      },
    },
    model: {
      get() {
        return this.$store.state.emission.carData.model;
      },
      set(value) {
        this.$store.dispatch("updateCarDataProperty", { key: "model", value });
      },
    },
    description: {
      get() {
        return this.$store.state.emission.carData.description;
      },
      set(value) {
        this.$store.dispatch("updateCarDataProperty", {
          key: "description",
          value,
        });
      },
    },
    vehicle_vin: {
      get() {
        return this.$store.state.emission.emissionRequest.vehicle_vin;
      },
      set(value) {
        this.$store.dispatch("updateEmissionRequestProperty", {
          key: "vehicle_vin",
          value,
        });
      },
    },
    vehicle_plate: {
      get() {
        return this.$store.state.emission.emissionRequest.vehicle_plate;
      },
      set(value) {
        this.$store.dispatch("updateEmissionRequestProperty", {
          key: "vehicle_plate",
          value,
        });
      },
    },

    allChecksActive() {
      const keys = Object.keys(this.requiredChecks);
      return !keys.filter((key) => this.requiredChecks[key] == false).length;
    },
  },

  watch: {
    active(v) {
      if (v) this.currentPanel = 0;
      else this.currentPanel = 1;
    },

    vehicle_vin(v) {
      if (v && v.length > 14 && v.length < 18) this.validateVehicleVin(false);
    },

    useSameVinAndSameQuotation(v){
      if(v)
        this.validateVehicleVin()
    }
  },

  methods: {
    async nextStep() {
      await this.$refs.form.validate();
      if (!this.isFormValid) return;
      window.dataLayer.push({
        event: "ITFY_auto_emitir_datos_vehiculo",
        no_cotizacion: this.cotizacionSelected.cotizacion_general,
        userID: localStorage.getItem('agenteMail'),
      })
      const emissionData = JSON.parse(sessionStorage.getItem('contractorData'))
      window.dataLayer.push({
        event: "ITFY_auto_emitir_datos_contratante_v",
        no_cotizacion: this.cotizacionSelected.cotizacion_general,
        userID: localStorage.getItem('agenteMail'),
        correo: emissionData?.emission?.contractorData?.email,
        telefono: emissionData?.emission?.contractorData?.phone,
      })
      this.$emit("nextStep");
    },

    async validateVehicleVin(firstTime) {
      var cotizacionSelected = JSON.parse(
        sessionStorage.getItem("cotizacionSelected")
      );
      this.loading = true;
      this.errors.vin = [];
      var validacion = await validateVin(
        this.vehicle_vin,
        cotizacionSelected.insurer
      );

      if (
        validacion.data.data.activePolicy ||
        validacion.data.data.is_active_policy
      )
      if (
          this.useSameVinAndSameQuotation &&
          (this.vehicle_vin == this.$store.state.emission.emissionRequest.vehicle_vin) &&
          (this.cotizacionSelected.id == validacion.data.data.cotizacion_id)
        )
          console.log("Vin valido porque es lo mismo ");

        else if (!this.useSameVinAndSameQuotation)
          this.errors.vin.push("Vin invalido o esta en uso");


      if (
        firstTime &&
        validacion.data.data.payment_link &&
        this.cotizacionSelected.id == validacion.data.data.cotizacion_id
      )
        this.$emit("directToPay");

      this.loading = false;
    },
  },
  created() {
    this.validateVehicleVin(true);
  },
  mounted() {
    const emissionData = JSON.parse(sessionStorage.getItem('contractorData'))
    if (this.active){
      window.dataLayer.push({
        event: 'ITFY_auto_emitir_datos_vehiculo_v',
        no_cotizacion: this.cotizacionSelected.cotizacion_general,
        userID: localStorage.agenteMail,
        correo: emissionData?.emission?.contractorData?.email,
        telefono: emissionData?.emission?.contractorData?.phone,
      });
    }
  }
};
</script>
